import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

export default function TermsAndConditions() {
  const { l, language } = useLanguage();
  useTheme();

  const updatedLabel = l('Last updated: ', 'နောက်ဆုံး အပ်ဒိတ်: ', '最后更新：');
  const dateLocale = language === 'zh' ? 'zh-CN' : language === 'my' ? 'my-MM' : 'en-US';

  return (
    <div className="min-h-screen bg-background py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-card rounded-lg shadow-lg p-6 md:p-8 lg:p-10">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2">
            {l('Terms and Conditions', 'စည်းကမ်းချက်များနှင့် သတ်မှတ်ချက်များ', '条款与条件')}
          </h1>
          <p className="text-muted-foreground mb-8">
            {updatedLabel + new Date().toLocaleDateString(dateLocale, { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>

          <div className="prose prose-lg max-w-none space-y-6 text-foreground">
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {l('1. Introduction', '၁။ မိတ်ဆက်', '1. 简介')}
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                {l(
                  'Welcome to Cosmic Learning, an independent, free English learning platform. This application is not affiliated with any organization, company, or educational institution. Our mission is to provide free, accessible English learning resources to everyone, regardless of their background or location.',
                  'Cosmic Learning မှ ကြိုဆိုပါသည်။ အခမဲ့ အင်္ဂလိပ်စာ သင်ယူရေး ပလက်ဖောင်း တစ်ခု ဖြစ်ပါသည်။ ကျွန်ုပ်တို့သည် မည်သည့် အဖွဲ့အစည်း၊ ကုမ္ပဏီ သို့မဟုတ် ပညာရေး အဖွဲ့အစည်းနှင့်မှ မဆက်စပ်ပါ။ ကျွန်ုပ်တို့၏ ရည်မှန်းချက်မှာ လူတိုင်းအတွက် အခမဲ့၊ လက်လှမ်းမီနိုင်သော အင်္ဂလိပ်စာ သင်ယူရေး အရင်းအမြစ်များ ပေးအပ်ရန် ဖြစ်ပါသည်။',
                  '欢迎使用 Cosmic Learning，这是一个独立的免费英语学习平台。本应用与任何组织、公司或教育机构无关。我们的使命是为所有人提供免费、易用的英语学习资源，无论其背景或所在地。'
                )}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {l('2. Acceptance of Terms', '၂။ စည်းကမ်းချက်များ လက်ခံခြင်း', '2. 接受条款')}
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                {l(
                  'By accessing and using Cosmic Learning, you accept and agree to be bound by these Terms and Conditions.',
                  'Cosmic Learning ကို အသုံးပြုခြင်းဖြင့် သင်သည် စည်းကမ်းချက်များကို လက်ခံပြီး လိုက်နာရန် သဘောတူပါသည်။',
                  '访问并使用 Cosmic Learning 即表示您接受并同意受这些条款与条件的约束。'
                )}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {l('3. Free Service', '၃။ အခမဲ့ ဝန်ဆောင်မှု', '3. 免费服务')}
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                {l(
                  'Cosmic Learning is provided completely free of charge. We do not charge any fees for accessing our learning materials, exercises, or features. Our platform is maintained independently without commercial interests.',
                  'Cosmic Learning ကို အခမဲ့ ပေးအပ်ထားပါသည်။ ကျွန်ုပ်တို့၏ သင်ယူရေး ပစ္စည်းများ၊ လေ့ကျင့်ခန်းများ သို့မဟုတ် အင်္ဂါရပ်များကို အသုံးပြုရန် မည်သည့် ကုန်ကျစရိတ်မှ မရှိပါ။ ကျွန်ုပ်တို့၏ ပလက်ဖောင်းကို စီးပွားရေး အကျိုးစီးပွားမရှိဘဲ လွတ်လပ်စွာ ထိန်းသိမ်းထားပါသည်။',
                  'Cosmic Learning 完全免费提供。访问我们的学习材料、练习或功能不收取任何费用。本平台独立维护，无商业利益。'
                )}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {l('4. User Responsibilities', '၄။ အသုံးပြုသူ၏ တာဝန်များ', '4. 用户责任')}
              </h2>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground ml-4">
                <li>
                  {l(
                    'You are responsible for maintaining the confidentiality of your account credentials.',
                    'သင်၏ အကောင့် အချက်အလက်များကို ထိန်းသိမ်းရန် တာဝန်ရှိပါသည်။',
                    '您有责任保管账户凭据的机密性。'
                  )}
                </li>
                <li>
                  {l(
                    'You agree to use the platform for educational purposes only and in a lawful manner.',
                    'ပလက်ဖောင်းကို ပညာရေး ရည်ရွယ်ချက်များအတွက် ဥပဒေနှင့်အညီ အသုံးပြုရန် သဘောတူပါသည်။',
                    '您同意仅出于教育目的并以合法方式使用本平台。'
                  )}
                </li>
                <li>
                  {l(
                    'You will not attempt to harm, disrupt, or interfere with the platform\'s functionality.',
                    'ပလက်ဖောင်း၏ လုပ်ဆောင်နိုင်စွမ်းကို ထိခိုက်စေရန်၊ နှောင့်ယှက်ရန် သို့မဟုတ် ဝင်ရောက်စွက်ဖက်ရန် ကြိုးစားမည် မဟုတ်ပါ။',
                    '您不会试图损害、破坏或干扰平台的功能。'
                  )}
                </li>
                <li>
                  {l(
                    'You will not share, copy, or redistribute our content for commercial purposes without permission.',
                    'ခွင့်ပြုချက်မရှိဘဲ ကျွန်ုပ်တို့၏ အကြောင်းအရာကို စီးပွားရေး ရည်ရွယ်ချက်များအတွက် မျှဝေခြင်း၊ ကူးယူခြင်း သို့မဟုတ် ပြန်လည် ဖြန့်ဝေခြင်း မပြုလုပ်ရပါ။',
                    '未经许可，您不得为商业目的分享、复制或重新分发我们的内容。'
                  )}
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {l('5. Suggestions and Feedback', '၅။ အကြံပြုချက်များနှင့် တုံ့ပြန်ချက်များ', '5. 建议与反馈')}
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                {l(
                  'We welcome and encourage suggestions, feedback, and contributions from all users. By submitting suggestions or feedback, you grant us the right to use, modify, and implement your ideas to improve the platform. We appreciate your input and will consider all suggestions, though we cannot guarantee implementation of every idea.',
                  'ကျွန်ုပ်တို့သည် အသုံးပြုသူ အားလုံးထံမှ အကြံပြုချက်များ နှင့် ပံ့ပိုးမှုများကို ကြိုဆို အားပေးပါသည်။ အကြံပြုချက်များ ပေးပို့ခြင်းဖြင့် သင်သည် ပလက်ဖောင်းကို မြှင့်တင်ရန် သင်၏ အကြံပြုချက်များကို အသုံးပြုရန် သဘောတူပါသည်။ ကျွန်ုပ်တို့သည် သင်၏ အကြံပြုချက်ကို တန်ဖိုးထားပြီး အကြံပြုချက် အားလုံးကို စဉ်းစားပါမည်၊ သို့သော် အကြံပြုချက် တစ်ခုစီတိုင်းကို အကောင်အထည်ဖော်ရန် အာမခံချက် မပေးနိုင်ပါ။',
                  '我们欢迎并鼓励所有用户提供建议、反馈和贡献。提交建议或反馈即表示您授权我们使用、修改和实施您的想法以改进平台。我们重视您的意见并会考虑所有建议，但无法保证每项想法都会被实现。'
                )}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {l('6. Intellectual Property', '၆။ နည်းပညာ ပိုင်ဆိုင်မှုမှုကြမ်း', '6. 知识产权')}
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                {l(
                  'All content, materials, exercises, and features on Cosmic Learning are provided for educational purposes. While we strive to use original and properly sourced content, some materials may be based on common educational resources. Users may use the content for personal learning purposes but may not claim ownership or use it for commercial purposes without permission.',
                  'Cosmic Learning တွင် အကြောင်းအရာ၊ လေ့ကျင့်ခန်းများနှင့် အင်္ဂါရပ်အားလုံးကို ပညာရေး ရည်ရွယ်ချက်များအတွက် ပေးအပ်ထားပါသည်။ ကျွန်ုပ်တို့သည် မူရင်း နှင့် သင့်လျော်စွာ ရင်းမြစ်ထားသော အကြောင်းအရာများကို အသုံးပြုရန် ကြိုးစားသော်လည်း အချို့သော ပစ္စည်းများသည် အသုံးများသော ပညာရေး အရင်းအမြစ်များအပေါ် အခြေခံနိုင်ပါသည်။ အသုံးပြုသူများသည် ကိုယ်ပိုင် သင်ယူရေး ရည်ရွယ်ချက်များအတွက် အကြောင်းအရာကို အသုံးပြုနိုင်သော်လည်း ပိုင်ဆိုင်မှု သို့မဟုတ် ခွင့်ပြုချက်မရှိဘဲ စီးပွားရေး ရည်ရွယ်ချက်များအတွက် အသုံးမပြုရပါ။',
                  'Cosmic Learning 上的所有内容、材料、练习和功能均用于教育目的。我们力求使用原创且来源正当的内容，但部分材料可能基于常见的教育资源。用户可将内容用于个人学习，但不得声称所有权或在未经许可的情况下用于商业目的。'
                )}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {l('7. Limitation of Liability', '၇။ တာဝန်ယူမှု ကန့်သတ်ချက်', '7. 责任限制')}
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                {l(
                  'Cosmic Learning is provided "as is" without warranties of any kind. As an independent platform, we do not guarantee uninterrupted or error-free service. We are not liable for any damages, losses, or issues arising from the use of our platform. Users acknowledge that they use the platform at their own risk.',
                  'Cosmic Learning ကို မည်သည့် အာမခံချက်မျှမရှိဘဲ "ရှိသည့်အတိုင်း" ပေးအပ်ထားပါသည်။ လွတ်လပ်သော ပလက်ဖောင်း တစ်ခု အဖြစ် ကျွန်ုပ်တို့သည် မရပ်တန့်သော သို့မဟုတ် အမှားအယွင်းမရှိသော ဝန်ဆောင်မှုကို အာမခံချက် မပေးနိုင်ပါ။ ကျွန်ုပ်တို့၏ ပလက်ဖောင်းကို အသုံးပြုခြင်းမှ ဖြစ်ပေါ်လာသော မည်သည့် ပျက်စီးမှု၊ ဆုံးရှုံးမှု သို့မဟုတ် ပြဿနာများအတွက် တာဝန်မရှိပါ။ အသုံးပြုသူများသည် မိမိတို့၏ အန္တရာယ်ဖြင့် ပလက်ဖောင်းကို အသုံးပြုကြောင်း အသိအမှတ်ပြုပါသည်။',
                  'Cosmic Learning 按"现状"提供，不提供任何形式的保证。作为独立平台，我们不保证服务不间断或无错误。对于因使用本平台而产生的任何损害、损失或问题，我们不承担责任。用户承认自行承担使用本平台的风险。'
                )}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {l('8. Changes to Terms', '၈။ စည်းကမ်းချက်များ ပြောင်းလဲခြင်း', '8. 条款变更')}
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                {l(
                  'We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting on this page. Your continued use of the platform after changes constitutes acceptance of the new terms. We encourage you to review this page periodically.',
                  'ကျွန်ုပ်တို့သည် ဤစည်းကမ်းချက်များကို မည်သည့်အချိန်တွင်မဆို ပြုပြင်ခွင့် ရှိပါသည်။ ပြောင်းလဲမှုများသည် ဤစာမျက်နှာတွင် ပို့စ်တင်ပြီး ချက်ချင်းသက်ရောက်ပါမည်။ ပြောင်းလဲမှုများ ပြီးနောက် ပလက်ဖောင်းကို ဆက်လက် အသုံးပြုခြင်းသည် စည်းကမ်းချက် အသစ်များကို လက်ခံခြင်း ဖြစ်ပါသည်။ ဤစာမျက်နှာကို ပုံမှန် ပြန်လည် စစ်ဆေးရန် တိုက်တွန်းအပ်ပါသည်။',
                  '我们保留随时修改这些条款与条件的权利。变更在本页面发布后立即生效。变更后继续使用平台即表示接受新条款。我们建议您定期查阅本页面。'
                )}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {l('9. Contact and Support', '၉။ ဆက်သွယ်ရန်နှင့် အကူအညီ', '9. 联系与支持')}
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                {l(
                  'If you have questions, suggestions, or concerns about these Terms and Conditions, please contact us. We value your feedback and are committed to maintaining a positive learning environment for all users.',
                  'ဤစည်းကမ်းချက်များနှင့် ပတ်သက်၍ မေးခွန်းများ၊ အကြံပြုချက်များ ရှိပါက ကျေးဇူးပြု၍ ဆက်သွယ် ေပးပါ။ ကျွန်ုပ်တို့သည် သင်၏ အကြံပြုချက်တိုင်းကို တန်ဖိုးထားပြီး အသုံးပြုသူ အားလုံးအတွက် အပြုသဘော ေဆာင် ေသာ သင်ကြားရေး တစ်ခုကို တည် ေဆာက်ရန် ကတိပြုထားပါသည်။',
                  '如对这些条款与条件有疑问、建议或顾虑，请联系我们。我们重视您的反馈，并致力于为所有用户维护积极的学习环境。'
                )}
              </p>
              <div className="mt-4">
                <a
                  href="https://wa.me/6587625331"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline font-medium"
                >
                  {l('Contact Us via WhatsApp', 'WhatsApp ဖြင့် ဆက်သွယ်ရန်', '通过 WhatsApp 联系我们')}
                </a>
              </div>
            </section>

            <section className="border-t border-border pt-6 mt-8">
              <p className="text-muted-foreground leading-relaxed italic">
                {l(
                  'Thank you for using Cosmic Learning. We hope our platform helps you on your English learning journey. Happy learning!',
                  'Cosmic Learning ကို အသုံးပြုတဲ့အတွက် ကျေးဇူးတင်ပါသည်။ ကျွန်ုပ်တို့၏ ပလက်ဖောင်းသည် သင်၏ အင်္ဂလိပ်စာ သင်ယူရေးအတွက် အ ေထာက်အကူ ဖြစ်မည်ဟု မျှော်လင့်ပါသည်။ ပျော်ရွှင်စွာ သင်ယူလိုက်ပါ။',
                  '感谢使用 Cosmic Learning。希望我们的平台能帮助您的英语学习之旅。祝学习愉快！'
                )}
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
